import React, { useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { Helmet } from 'react-helmet'
import { loginInstructionCardData } from '../../data/pageInfoCardData'
import { fixedAuthFooterData } from '../../data/footerData'
import { cancelModalContent } from '../../data/modalContentData'
import PageWrapper from '../../components/PageWrapper'
import PageContentWrapper from '../../components/PageWrapper/PageContentWrapper'
import PageHeader from '../../components/PageHeader'
import InstructionCard from '../../components/InstructionCard'
import InputCard from '../../components/InputCard'
import PairNavButton from '../../components/PairNavButton'
import PageFooter from '../../components/PageFooter'
import PageModal from '../../components/PageModal'

const CustomerLogin = () => {
  const navigate = useNavigate()
  const [customerIdInputValue, setCustomerIdInputValue] = useState('')
  const [openModal, setOpenModal] = useState(false)
  const [navModalBtnFocused, setNavModalBtnFocused] = useState(false)
  useEffect(() => {
    if (navModalBtnFocused) {
      setNavModalBtnFocused(false)
    }
  }, [navModalBtnFocused])
  function closeModal() {
    setOpenModal(false)
    setNavModalBtnFocused(true)
  }

  function onCustomerIdInputChange(event) {
    setCustomerIdInputValue(event.target.value)
  }

  const InputCardData = {
    label: 'Customer ID',
    onInputChange: (e) => onCustomerIdInputChange(e),
    defaultValue: customerIdInputValue,
    helpContent:
      'Having trouble with your details? Contact Bank 1 for assistance.',
  }
  const BottomNavButtonData = {
    leftButton: 'Cancel',
    leftButtonFunc: () => setOpenModal(!openModal),
    isLeftBtnFocused: navModalBtnFocused,
    rightButton: 'Continue',
    rightButtonFunc: () => navigate('/password'),
    isRightButtonDisabled: customerIdInputValue.length < 1 ? true : false,
    leftButtonLabel:
      'cancel button, to open the cancel process modal double click here',
    rightButtonLabel:
      customerIdInputValue.length > 0
        ? 'continue button, to get one time password double click here'
        : 'continue button Disabled, please input your customer ID',
  }

  const pageModalData = {
    isOpen: openModal,
    onClose: () => closeModal(),
    data: {
      ...cancelModalContent,
      leftButton: 'No',
      leftButtonFunc: () => closeModal(),
      rightButton: 'Yes',
      rightButtonFunc: () => navigate('/process-cancel'),
    },
  }

  return (
    <PageWrapper isModalOpen={openModal}>
      <Helmet>
        <title>Customer Login</title>
        <link rel="icon" href="./asset/bankIcon.svg" />
      </Helmet>
      <PageContentWrapper isModalOpen={openModal}>
        <PageHeader
          headerTitle="Bank 1"
          workflow="Auth"
          isFocused={true}
          titleLabel="banks 1: login page"
        />
        <InstructionCard {...loginInstructionCardData} />
        <InputCard {...InputCardData} />
        <PairNavButton {...BottomNavButtonData} />
      </PageContentWrapper>
      <PageFooter {...fixedAuthFooterData} />
      <PageModal {...pageModalData} />
    </PageWrapper>
  )
}

export default CustomerLogin
